import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "voucher-header" };
const _hoisted_2 = { class: "voucher-info" };
const _hoisted_3 = { class: "merchant-logo" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = { class: "merchant-name" };
const _hoisted_6 = { class: "voucher-amount" };
const _hoisted_7 = { class: "amount-text" };
const _hoisted_8 = ["title"];
const _hoisted_9 = { class: "voucher-details" };
const _hoisted_10 = { class: "cashback-info" };
const _hoisted_11 = { class: "cashback-badge" };
const _hoisted_12 = { class: "cashback-percentage" };
const _hoisted_13 = { class: "cashback-text" };
const _hoisted_14 = { class: "cashback-amount" };
const _hoisted_15 = { class: "item-controls" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherCartItem',
    props: {
        logoUrl: {},
        merchantName: {},
        amount: {},
        cashbackPercentage: {},
        formatter: {},
        showBorder: { type: Boolean },
        showDelete: { type: Boolean }
    },
    emits: ["edit", "delete"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["voucher-item", { 'border-bottom': _ctx.showBorder }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", {
                                src: _ctx.logoUrl,
                                alt: _ctx.merchantName
                            }, null, 8, _hoisted_4)
                        ]),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.merchantName), 1),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatter.format(parseFloat(String(_ctx.amount)))), 1),
                            (_ctx.showDelete)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "delete-button",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('delete'))),
                                    title: `Remove ${_ctx.merchantName} voucher`
                                }, [
                                    _createVNode(_component_v_icon, { size: "12" }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode("mdi-close")
                                        ])),
                                        _: 1
                                    })
                                ], 8, _hoisted_8))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.cashbackPercentage) + "%", 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "cashback-label" }, "Cashback", -1)),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatter.format(parseFloat(String(_ctx.amount)) * _ctx.cashbackPercentage / 100)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                            class: "edit-button",
                            onClick: _cache[1] || (_cache[1] = ($event) => (emit('edit')))
                        }, _cache[4] || (_cache[4] = [
                            _createElementVNode("span", null, "Edit", -1)
                        ]))
                    ])
                ])
            ], 2));
        };
    }
});
